/**
 * Student API — add/edit/delete students for a university (used by prof and university_admin).
 * All calls use backend routes under /api/universities (users with role=student).
 */
import {
  GetUniversityUsersCall,
  AddUniversityUsersCall,
  EditUniversityUserCall,
  RemoveUniversityUserCall,
} from "./university.api";

// GET /api/universities/:university_id/users?role=student
export const GetUniversityStudentsCall = async (universityId) => {
  if (!universityId) return [];
  return GetUniversityUsersCall(universityId, "student");
};

// POST /api/universities/users — add a student to the university
export const AddUniversityStudentCall = async (body) => {
  return AddUniversityUsersCall({ ...body, role: "student" });
};

// PUT /api/universities/users/:user_id — edit a student
export const EditUniversityStudentCall = async (userId, body) => {
  return EditUniversityUserCall(userId, body);
};

// DELETE /api/universities/users/:user_id — remove a student from the university
export const RemoveUniversityStudentCall = async (userId) => {
  return RemoveUniversityUserCall(userId);
};
